export function isLengthLarger(text, number) {
    return text.length >= number
}